import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { CustomValidator } from '../../../core/_infrastructure/classes/customValidator';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { Tc, TcPerfilUsuarioEnum, TUsuarioPerfilViewModel } from '../../../core/_infrastructure/types/common';
import { PuntoInspeccionService } from '../../../_mantenimiento/general/puntosinspeccion/puntoinspeccion.service';
import { PuntoInspeccionUsuarioViewModel } from '../../../_mantenimiento/general/puntosinspeccion/puntoinspeccion.types';
import { UsuariosService } from '../usuarios.service';
import { TUsuarioPuntoInspeccionViewModel, TwUsuarioCaViewModel, TwUsuarioInspectorViewModel, UsuarioViewModel } from '../usuarios.types'; //PersonalFitoProvinciaViewModel,

@Component({
    selector: 'app-usuarioscexveg-edit',
    templateUrl: './usuarioscexveg-edit.component.html',
})
export class UsuarioscexvegEditComponent extends ComponentBase implements OnInit {
    editMode: boolean;
    editTitle = 'Nuevo';

    public isCollapsedDatosUser = false;
    public isCollapsedPerfiles = false;

    public mostrarDatosComunidad = false;
    public mostrarDatosInspector = false;
    //public mostrarZona = false;
    //public mostrarProvincias = false;
    public mostrarPuntosInspeccion = false;
    visibilitySpinner = false;

    listPerfiles: Tc[];
    listComAuts: Tc[];

    listProvincias: Tc[];
    listPuntosInspeccion: PuntoInspeccionUsuarioViewModel[];

    usuario: UsuarioViewModel;

    //Constructor
    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        protected notificationService: NotificationService,
        private confirmationService: ConfirmationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private usuarioService: UsuariosService,
        private pifService: PuntoInspeccionService,
    ) {
        super(authService, notificationService, exceptionHandler);

        this.usuario = new UsuarioViewModel();
    }

    ngOnInit() {
        this.globalService.getPerfilesUsuarioCexveg().subscribe(result => {
            this.listPerfiles = result;

            //Si es coordinador y no Admin ni MAPA, solo se deja el perfil inspector.
            if (this.isCoordinador && (!this.isAdmin || !this.loggedInUser!.hasProfile(TcPerfilUsuarioEnum.Magrama))) {
                this.listPerfiles = this.listPerfiles.filter(it => it.Id == TcPerfilUsuarioEnum.Inspector.valueOf());
            }
        });

        this.globalService.getComunidadesAutonomas().subscribe(result => {
            this.listComAuts = result;
        });

        this.globalService.getProvincias().subscribe(result => {
            this.listProvincias = result;
        });

        this.pifService.getPuntosInspeccionUsuarios().subscribe(result => {
            this.listPuntosInspeccion = result;
        });

        //Ver como cargar los pifs

        let id = +this.activatedRoute.snapshot.params['id'];

        if (id) {
            this.editMode = true;
            this.editTitle = 'Editar';

            this.usuarioService.getUsuarioCexveg(id).subscribe(result => {
                this.usuario = result;
                this.updateForm();

                this.inicializarVentanaEdicion();
            });
        } else {
            //Sin perfiles si es un alta, que no se vean las secciones que dependen de ellos
            this.mostrarDatosComunidad = false;
            this.mostrarDatosInspector = false;
            //this.mostrarProvincias = false;
            this.mostrarPuntosInspeccion = false;
            //this.mostrarZona = false;
        }

        this.createForm();

        if (!this.editMode) {
            /* empty */
        }

        //this.form.controls['IdPais'].disable();
        this.form.controls['FechaCreacion'].disable();
        this.form.controls['FechaActivacion'].disable();
        this.form.controls['FechaBaja'].disable();

        //Contenedores. Abrimos solo el primero.
        this.isCollapsedDatosUser = false;
        this.isCollapsedPerfiles = false;
    }

    private createForm(): void {
        let currentGrupo = this.fb.group({
            Nombre: ['', Validators.required],
            Apellidos: ['', Validators.required],
            Nif: ['', Validators.compose([Validators.required, CustomValidator.NIFValidator])],
            Email: ['', Validators.compose([Validators.required, CustomValidator.emailEmptyValidator])],
            Activo: true,
            AutorizadoImportacion: true,
            AutorizadoExportacion: true,

            FechaCreacion: '',
            FechaActivacion: '',
            FechaBaja: '',

            IdPerfil: null,

            IdComunidadAutonoma: null,
            AutorizadoCertificacionEx: false,
            AutorizadoCampanias: false,
            IdProvincia: null,
            IdPuntoInspeccion: null,
        });

        this.form = currentGrupo;
    }

    private updateForm(): void {
        this.form.setValue({
            Nombre: this.usuario.Nombre,
            Apellidos: this.usuario.Apellidos,
            Nif: this.usuario.Nif,
            Email: this.usuario.Email,
            Activo: this.usuario.Activo,
            AutorizadoImportacion: this.usuario.TwUsuarioInspector != null ? this.usuario.TwUsuarioInspector.AutorizadoImportacion : false,
            AutorizadoExportacion: this.usuario.TwUsuarioInspector != null ? this.usuario.TwUsuarioInspector.AutorizadoExportacion : false,

            FechaCreacion: new Date(this.usuario.FechaCreacion),
            FechaActivacion: this.usuario.FechaActivacion != null ? new Date(this.usuario.FechaActivacion) : '',
            FechaBaja: this.usuario.FechaBaja != null ? new Date(this.usuario.FechaBaja) : '',

            IdPerfil: null,

            IdComunidadAutonoma: this.usuario.TwUsuarioCa != null ? this.usuario.TwUsuarioCa.IdCa : 0,
            AutorizadoCertificacionEx: this.usuario.TwUsuarioCa != null ? this.usuario.TwUsuarioCa.AutorizadoCertificacionEx : false,
            AutorizadoCampanias: this.usuario.TwUsuarioCa != null ? this.usuario.TwUsuarioCa.AutorizadoCampanias : false,
            //IdZona: null,
            IdProvincia: null,
            IdPuntoInspeccion: null,
        });
    }

    onSubmit(): void {
        let validacionesDeColleccion = false;

        if (this.usuario.TUsuarioPerfilCollection == null || this.usuario.TUsuarioPerfilCollection.length == 0) {
            this.form.patchValue({
                IdPerfil: null,
            });

            this.addValidator('IdPerfil', Validators.required);
            validacionesDeColleccion = true;
        }

        if (this.mostrarPuntosInspeccion) {
            if (this.usuario.TUsuarioPuntoInspeccionCollection == null || this.usuario.TUsuarioPuntoInspeccionCollection.length == 0) {
                this.form.patchValue({
                    IdPuntoInspeccion: null,
                });

                this.addValidator('IdPuntoInspeccion', Validators.required);
                validacionesDeColleccion = true;
            }
        }

        this.submitted = true;

        if (!this.form.valid || validacionesDeColleccion) {
            //Abrimos los contenedores.
            this.addErrorMessage('Revise los datos del Usuario Cexveg antes de guardar.');

            this.isCollapsedDatosUser = false;
            return;
        }

        this.visibilitySpinner = true;

        let usuario = new UsuarioViewModel();

        usuario.Nombre = this.form.value.Nombre;
        usuario.Apellidos = this.form.value.Apellidos;
        usuario.Nif = this.form.value.Nif;
        usuario.Email = this.form.value.Email;
        usuario.Activo = this.form.value.Activo;

        //usuario.FechaCreacion = this.form.value.FechaCreacion;
        //usuario.FechaActivacion = this.form.value.FechaActivacion;
        //usuario.FechaBaja = this.form.value.FechaBaja;

        //usuario.IdZona = this.form.value.IdZona;
        if (this.mostrarDatosComunidad) {
            usuario.TwUsuarioCa = this.usuario.TwUsuarioCa;
            usuario.TwUsuarioCa.IdCa = this.form.value.IdComunidadAutonoma;
            usuario.TwUsuarioCa.AutorizadoCertificacionEx = this.form.value.AutorizadoCertificacionEx;
            usuario.TwUsuarioCa.AutorizadoCampanias = this.form.value.AutorizadoCampanias;
            usuario.TwUsuarioCa.IdUsuario = usuario.Id;
        }

        if (this.mostrarDatosInspector) {
            usuario.TwUsuarioInspector = this.usuario.TwUsuarioInspector;
            usuario.TwUsuarioInspector.AutorizadoImportacion = this.form.value.AutorizadoImportacion;
            usuario.TwUsuarioInspector.AutorizadoExportacion = this.form.value.AutorizadoExportacion;
            usuario.TwUsuarioInspector.IdUsuario = usuario.Id;
        }

        if (this.editMode) {
            usuario.FechaCreacion = this.usuario.FechaCreacion;
            usuario.FechaActivacion = this.usuario.FechaActivacion;
            usuario.FechaBaja = this.usuario.FechaBaja;
        }

        usuario.Id = this.usuario.Id;

        //Colecciones
        usuario.TUsuarioPerfilCollection = this.usuario.TUsuarioPerfilCollection;
        usuario.TUsuarioPuntoInspeccionCollection = this.usuario.TUsuarioPuntoInspeccionCollection;

        if (this.editMode) {
            this.usuarioService.editUsuario(usuario).subscribe({
                next: res => {
                    this.addSuccessMessage('Usuario Cexveg modificado correctamente');
                    this.onBack();
                    this.visibilitySpinner = false;
                },
                error: error => {
                    this.catchServerError(error);
                    this.addErrorMessage('Error al guardar. Revise los datos del Usuario Cexveg');
                    this.visibilitySpinner = false;
                    //Abrimos todos los contenedores.
                    this.isCollapsedDatosUser = false;
                },
            });
        } else {
            this.usuarioService.createUsuario(usuario).subscribe({
                next: res => {
                    this.addSuccessMessage('Usuario Cexveg creado correctamente');
                    this.onBack();
                    this.visibilitySpinner = false;
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                },
            });
        }
    }

    sortByPif(prop: string): any {
        if (this.editMode) {
            return this.usuario.TUsuarioPuntoInspeccionCollection.sort(function (a, b) {
                return a.Descripcion.localeCompare(b.Descripcion);
            });
        } else {
            return this.usuario.TUsuarioPuntoInspeccionCollection;
        }
    }

    //PERFILES

    onAddPerfil(): void {
        if (this.form.value.IdPerfil != null && this.form.value.IdPerfil > 0) {
            this.removeValidators('IdPerfil');
            this.addValidator('IdPerfil', Validators.required);

            if (this.isFieldInvalidNoSubmit('IdPerfil', 'required')) {
                return;
            }

            this.removeValidators('IdPerfil');

            let currentPerfil = new TUsuarioPerfilViewModel();
            currentPerfil.IdPerfil = this.form.value.IdPerfil;
            currentPerfil.IdUsuario = this.usuario.Id; //this.loggedInUser!.Id;

            if (this.usuario.TUsuarioPerfilCollection == null) {
                this.usuario.TUsuarioPerfilCollection = new Array<TUsuarioPerfilViewModel>();
            }

            //Comprobamos que no esté ya incluido
            let yaIncluido = this.usuario.TUsuarioPerfilCollection.find(it => it.IdPerfil == currentPerfil.IdPerfil);

            if (yaIncluido) {
                return;
            }

            //Si no está incluido todavía, actualizamos el listbox

            let perfilSeleccionado = this.listPerfiles.find(it => it.Id == this.form.value.IdPerfil);
            currentPerfil.Descripcion = perfilSeleccionado!.Descripcion;

            //Añadimos la validación de la CA
            if (currentPerfil.Id == TcPerfilUsuarioEnum.ComunidadAutonoma.valueOf()) {
                this.addValidator('IdComunidadAutonoma', Validators.required);
            }

            //this.usuario.TPerfilUsuarioCollection.push(this.listPerfiles
            this.usuario.TUsuarioPerfilCollection.push(currentPerfil);

            //Quitamos el valor del desplegable.
            //this.listPerfiles = this.listPerfiles.filter(it => it.Id != perfilSeleccionado!.Id);

            this.inicializarVentanaEdicion();

            this.removeValidators('IdPerfil');

            this.form.patchValue({
                IdPerfil: null,
            });

            //this.addValidator("IdPerfil", Validators.required);
        }
    }

    onDeletePerfil(item: TUsuarioPerfilViewModel): void {
        //Tenemos que ver si está seguro de borrar el perfil, si es:
        //1 - CA
        //2- Es perfil con Pifs
        //3 - El último entre los siguientes perfiles: Inspector, Coordinador, Consultas, CA, Grabador

        let cuantosPerfilesConPif = this.usuario.TUsuarioPerfilCollection.filter(
            it =>
                //it.IdPerfil == TcPerfilUsuarioEnum.ComunidadAutonoma ||
                it.IdPerfil == TcPerfilUsuarioEnum.Coordinador ||
                it.IdPerfil == TcPerfilUsuarioEnum.Inspector ||
                it.IdPerfil == TcPerfilUsuarioEnum.Consultas ||
                it.IdPerfil == TcPerfilUsuarioEnum.Grabador,
        ).length;

        if ((this.esPerfilConPifs(item.IdPerfil) && cuantosPerfilesConPif == 1) || item.IdPerfil == TcPerfilUsuarioEnum.ComunidadAutonoma.valueOf()) {
            this.confirmationService.confirm({
                message: '¿Está seguro de eliminar el perfil ' + item.Descripcion + '?\n\n Tenga en cuenta que se borrarán datos asociados.',

                accept: () => {
                    //Quitamos la validación de la CA
                    if (item.Id == TcPerfilUsuarioEnum.ComunidadAutonoma.valueOf()) {
                        this.removeValidators('IdComunidadAutonoma');
                    }

                    this.usuario.TUsuarioPerfilCollection.splice(this.usuario.TUsuarioPerfilCollection.indexOf(item), 1);
                    this.inicializarVentanaEdicion();
                },
            });
        } else {
            this.usuario.TUsuarioPerfilCollection.splice(this.usuario.TUsuarioPerfilCollection.indexOf(item), 1);
            this.inicializarVentanaEdicion();
        }
    }

    onAddAllPifs(): void {
        if (this.listPuntosInspeccion != null) {
            for (let i = 0, len = this.listPuntosInspeccion.length; i < len; i++) {
                let currentPif = new TUsuarioPuntoInspeccionViewModel();
                currentPif.IdPuntoInspeccion = this.listPuntosInspeccion[i].Id;
                currentPif.IdUsuario = this.usuario.Id;

                if (this.usuario.TUsuarioPuntoInspeccionCollection == null) {
                    this.usuario.TUsuarioPuntoInspeccionCollection = new Array<TUsuarioPuntoInspeccionViewModel>();
                }

                //Comprobamos que no esté ya incluido
                let yaIncluido = this.usuario.TUsuarioPuntoInspeccionCollection.find(it => it.IdPuntoInspeccion == currentPif.IdPuntoInspeccion);

                if (!yaIncluido) {
                    //Si no está incluido todavía, actualizamos el listbox

                    currentPif.Descripcion = this.listPuntosInspeccion[i].Descripcion;

                    this.usuario.TUsuarioPuntoInspeccionCollection.push(currentPif);

                    this.removeValidators('IdPuntoInspeccion');

                    //this.form.patchValue({
                    //    IdPuntoInspeccion: null,
                    //});
                }
            }
        }
    }

    //PUNTOS DE INSPECCION
    onAddPuntoInspeccion(): void {
        if (this.form.value.IdPuntoInspeccion != null && this.form.value.IdPuntoInspeccion > 0) {
            this.removeValidators('IdPuntoInspeccion');
            this.addValidator('IdPuntoInspeccion', Validators.required);

            if (this.isFieldInvalidNoSubmit('IdPuntoInspeccion', 'required')) {
                return;
            }

            this.removeValidators('IdPuntoInspeccion');

            let currentPif = new TUsuarioPuntoInspeccionViewModel();
            currentPif.IdPuntoInspeccion = this.form.value.IdPuntoInspeccion;
            currentPif.IdUsuario = this.usuario.Id;

            if (this.usuario.TUsuarioPuntoInspeccionCollection == null) {
                this.usuario.TUsuarioPuntoInspeccionCollection = new Array<TUsuarioPuntoInspeccionViewModel>();
            }

            //Comprobamos que no esté ya incluido
            let yaIncluido = this.usuario.TUsuarioPuntoInspeccionCollection.find(it => it.IdPuntoInspeccion == currentPif.IdPuntoInspeccion);

            if (yaIncluido) {
                return;
            }

            //Si no está incluido todavía, actualizamos el listbox

            let pifSeleccionado = this.listPuntosInspeccion.find(it => it.Id == this.form.value.IdPuntoInspeccion);

            if (pifSeleccionado != null) {
                currentPif.Descripcion = pifSeleccionado.Descripcion;
            }

            //this.usuario.TPerfilUsuarioCollection.push(this.listPerfiles
            this.usuario.TUsuarioPuntoInspeccionCollection.push(currentPif);

            //this.gestionVisibilidadesSegunPerfil(currentPerfil.IdPerfil, true);

            //this.removeValidators("IdPuntoInspeccion");

            this.form.patchValue({
                IdPuntoInspeccion: null,
            });

            //this.addValidator("IdPuntoInspeccion", Validators.required);
        }
    }

    onAddPuntoInspeccionPorProvincia(): void {
        if (this.form.value.IdProvincia != null && this.form.value.IdProvincia > 0) {
            let pifsProvincia = this.listPuntosInspeccion.filter(it => it.IdProvincia == this.form.value.IdProvincia);

            if (pifsProvincia != null) {
                for (let i = 0, len = pifsProvincia.length; i < len; i++) {
                    let currentPif = new TUsuarioPuntoInspeccionViewModel();
                    currentPif.IdPuntoInspeccion = pifsProvincia[i].Id;
                    currentPif.IdUsuario = this.usuario.Id;

                    if (this.usuario.TUsuarioPuntoInspeccionCollection == null) {
                        this.usuario.TUsuarioPuntoInspeccionCollection = new Array<TUsuarioPuntoInspeccionViewModel>();
                    }

                    //Comprobamos que no esté ya incluido
                    let yaIncluido = this.usuario.TUsuarioPuntoInspeccionCollection.find(it => it.IdPuntoInspeccion == currentPif.IdPuntoInspeccion);

                    if (!yaIncluido) {
                        //Si no está incluido todavía, actualizamos el listbox

                        currentPif.Descripcion = pifsProvincia[i].Descripcion;

                        //this.usuario.TPerfilUsuarioCollection.push(this.listPerfiles
                        this.usuario.TUsuarioPuntoInspeccionCollection.push(currentPif);

                        //this.gestionVisibilidadesSegunPerfil(currentPerfil.IdPerfil, true);

                        this.removeValidators('IdPuntoInspeccion');

                        this.form.patchValue({
                            IdPuntoInspeccion: null,
                        });
                    }
                }
            }

            //this.addValidator("IdPuntoInspeccion", Validators.required);
        }
    }

    onDeletePuntoInspeccion(item: TUsuarioPuntoInspeccionViewModel): void {
        this.usuario.TUsuarioPuntoInspeccionCollection.splice(this.usuario.TUsuarioPuntoInspeccionCollection.indexOf(item), 1);
    }

    private inicializarVentanaEdicion(): void {
        //Dependiendo de si contiene o no ciertos perfiles el usuario mostramos el resto de colecciones.

        //Datos Comunidad
        this.mostrarDatosComunidad = this.usuario.TUsuarioPerfilCollection.some(it => it.IdPerfil == TcPerfilUsuarioEnum.ComunidadAutonoma);
        //Datos Inspector
        this.mostrarDatosInspector = this.usuario.TUsuarioPerfilCollection.some(it => it.IdPerfil == TcPerfilUsuarioEnum.Inspector);

        if (this.mostrarDatosComunidad) {
            if (this.usuario.TwUsuarioCa != null) {
                this.usuario.TwUsuarioCa.AutorizadoCertificacionEx = false;
                this.usuario.TwUsuarioCa.AutorizadoCampanias = false;
                this.usuario.TwUsuarioCa.IdCa = 0;
                this.usuario.TwUsuarioCa.IdUsuario = 0;
            } else {
                this.usuario.TwUsuarioCa = new TwUsuarioCaViewModel();
            }

            this.addValidator('IdComunidadAutonoma', Validators.required);
        } else {
            this.removeValidators('IdComunidadAutonoma');

            this.form.patchValue({
                IdComunidadAutonoma: null,
            });
        }

        if (this.mostrarDatosInspector) {
            if (this.usuario.TwUsuarioInspector != null) {
                this.usuario.TwUsuarioInspector.AutorizadoImportacion = false;
                this.usuario.TwUsuarioInspector.AutorizadoExportacion = false;
                this.usuario.TwUsuarioInspector.IdUsuario = 0;
            } else {
                this.usuario.TwUsuarioInspector = new TwUsuarioInspectorViewModel();
            }
        }

        //Provincias - Inspector, Grabador, Comunidad Autónoma, Coordinador, Consultas
        this.mostrarPuntosInspeccion = this.usuario.TUsuarioPerfilCollection.some(
            it =>
                //it.IdPerfil == TcPerfilUsuarioEnum.ComunidadAutonoma ||
                it.IdPerfil == TcPerfilUsuarioEnum.Coordinador ||
                it.IdPerfil == TcPerfilUsuarioEnum.Inspector ||
                it.IdPerfil == TcPerfilUsuarioEnum.Consultas ||
                it.IdPerfil == TcPerfilUsuarioEnum.Grabador,
        );

        if (!this.mostrarPuntosInspeccion) {
            this.form.patchValue({
                IdPuntoInspeccion: null,
                IdProvincia: null,
            });

            if (this.usuario.TUsuarioPuntoInspeccionCollection != null && this.usuario.TUsuarioPuntoInspeccionCollection.length > 0) {
                this.usuario.TUsuarioPuntoInspeccionCollection.splice(0, this.usuario.TUsuarioPuntoInspeccionCollection.length + 1);
            }
        }

        //this.mostrarZona = mostrarDatosZonaProvinciaPif;
        //this.mostrarProvincias = mostrarDatosZonaProvinciaPif;
        //this.mostrarPuntosInspeccion = mostrarDatosZonaProvinciaPif;
    }

    private esPerfilConPifs(idPerfil: number): any {
        return (
            //idPerfil == TcPerfilUsuarioEnum.ComunidadAutonoma ||
            idPerfil == TcPerfilUsuarioEnum.Coordinador ||
            idPerfil == TcPerfilUsuarioEnum.Inspector ||
            idPerfil == TcPerfilUsuarioEnum.Consultas ||
            idPerfil == TcPerfilUsuarioEnum.Grabador
        );
    }

    onBack(): void {
        if (!this.editMode) {
            this.addSuccessMessage('Datos enviados correctamente');
            this.router.navigate(['/mantenimiento/usuarios/usuarioscexveg']);
        } else {
            this.router.navigate(['/mantenimiento/usuarios/usuarioscexveg']);
        }
    }
}
